import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import * as TeamTypeActions from './team-types.actions';
import { TeamTypeService } from '@/core/admin/services/team-type.service';
import { MessageService } from 'primeng/api';

@Injectable()
export class TeamTypeEffects {
  private actions$ = inject(Actions);
  private teamTypeService = inject(TeamTypeService);
  private messageService = inject(MessageService);

  loadTeamTypes$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamTypeActions.loadTeamTypes),
      switchMap(() =>
        this.teamTypeService.getTeamTypes().pipe(
          map((teamTypes) => TeamTypeActions.loadTeamTypesSuccess({ teamTypes })),
          catchError((error) => of(TeamTypeActions.loadTeamTypesFailure({ error })))
        )
      )
    )
  );

  createTeamType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamTypeActions.createTeamType),
      switchMap(({ teamType }) =>
        this.teamTypeService.createTeamType(teamType).pipe(
          map((newTeamType) => TeamTypeActions.createTeamTypeSuccess({ teamType: newTeamType })),
          tap(() => this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Team Type created successfully' })),
          catchError((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to create Team Type' });
            return of(TeamTypeActions.createTeamTypeFailure({ error }));
          })
        )
      )
    )
  );

  updateTeamType$ = createEffect(() =>
    this.actions$.pipe(
      ofType(TeamTypeActions.updateTeamType),
      switchMap(({ id, teamType }) =>
        this.teamTypeService.updateTeamType(id, teamType).pipe(
          map((updatedTeamType) => TeamTypeActions.updateTeamTypeSuccess({ teamType: updatedTeamType })),
          tap(() => this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Team Type updated successfully' })),
          catchError((error) => {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to update Team Type' });
            return of(TeamTypeActions.updateTeamTypeFailure({ error }));
          })
        )
      )
    )
  );
}
